module.exports = __webpack_public_path__ + "static/media/left.963f52a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/images/left.jpg
// module id = 337
// module chunks = 0